import { render, staticRenderFns } from "./About_generali.vue?vue&type=template&id=1377b995&scoped=true&"
import script from "./About_generali.vue?vue&type=script&lang=js&"
export * from "./About_generali.vue?vue&type=script&lang=js&"
import style0 from "./About_generali.vue?vue&type=style&index=0&id=1377b995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377b995",
  null
  
)

export default component.exports